'use client';
import { XYCHART_SERIES_TYPE } from './xychart-types';
import type { XYChartPreviewSeries } from './xychart-compact-preview-model';
export interface XYChartFadedSparkSeriesProps {
    series: XYChartPreviewSeries;
    categoryLabels: string[];
    stepX: number;
    xPositionFor: (index: number) => number;
    yPositionFor: (value: number) => number;
    zeroY: number;
}
const FADED_SPARK_SERIES_GROUP_NAME = 'fadedSparkSeriesGroup';
const FADED_SPARK_BAR_NAME = 'fadedSparkBar';
const FADED_SPARK_LINE_NAME = 'fadedSparkLine';
function getFadedSparkPointIdentity({ categoryLabel, value, }: {
    categoryLabel: string | undefined;
    value: number;
}): string {
    return categoryLabel ? `point-${categoryLabel}` : `value-${value}`;
}
export function XYChartFadedSparkSeries({ series, categoryLabels, stepX, xPositionFor, yPositionFor, zeroY, }: XYChartFadedSparkSeriesProps) {
    const points = series.data.map((value, index) => ({
        x: xPositionFor(index),
        y: yPositionFor(value),
    }));
    if (points.length < 2)
        return null;
    if (series.type === XYCHART_SERIES_TYPE.Bar) {
        const barWidth = Math.max(2, stepX * 0.4);
        return (
      <g opacity={0.15}>
        {series.data.map((value, index) => {
                const py = yPositionFor(value);
                const top = Math.min(py, zeroY);
                const heightPx = Math.max(1, Math.abs(zeroY - py));
                const cx = xPositionFor(index) - barWidth / 2;
                const pointIdentity = getFadedSparkPointIdentity({
                    categoryLabel: categoryLabels[index],
                    value,
                });
                return (<rect key={`faded-bar-${pointIdentity}`} x={cx} y={top} width={barWidth} height={heightPx} rx={barWidth / 2} fill={series.color}/>);
            })}
      </g>
      );
    }
    const linePath = `M ${points[0].x.toFixed(2)} ${points[0].y.toFixed(2)} ` +
        points
            .slice(1)
            .map((point) => `L ${point.x.toFixed(2)} ${point.y.toFixed(2)}`)
            .join(' ');
    return (
    <path d={linePath} fill="none" stroke="rgba(255, 255, 255, 0.2)" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
    );
}
